import React from "react";
import { Box } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, style, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={style}
      {...other}
    >
      {value === index && (
        <Box 
          p={3}
          sx={{
            height: style?.height || 'auto',
            display: style?.display || 'block',
            flexDirection: style?.flexDirection || 'column',
            ...(style?.minHeight !== undefined && { minHeight: style.minHeight }),
          }}
        >
          {children}
        </Box>
      )}
    </div>
  );
}

export default TabPanel;
